import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import AccountGroupSection from './AccountGroupSection';
import { CATEGORY_ORDER } from '../../utils/accountTypes';
import {
  EMPTY_GROUP_LABEL, GROUP_BY_INSTITUTION, GROUP_BY_TYPE, institutionLogo,
} from '../../utils/accountGrouping';

function orderedGroupKeys(accountsByGroup) {
  const present = Object.keys(accountsByGroup);
  const known = CATEGORY_ORDER.filter(g => present.includes(g));
  const unknown = present.filter(g => !CATEGORY_ORDER.includes(g)).sort();
  return [...known, ...unknown];
}

export default function AccountsList({
  accountsByGroup,
  groupBy,
  accountStats,
  roiByAccount,
  currency,
  approx = false,
  convert = null,
  multiCurrency = false,
  perCurrencyAccountStats,
  selectedAccountId,
  onAccountClick,
  freshness,
}) {
  const { t } = useTranslation('accounts');
  const byType = groupBy === GROUP_BY_TYPE;
  // Grouped any other way, the groups arrive already in display order
  // (institutions A→Z, years oldest first; the group with no key last).
  const groups = byType ? orderedGroupKeys(accountsByGroup) : Object.keys(accountsByGroup);
  return (
    <Box>
      {groups.map(g => (
        <AccountGroupSection
          key={g || 'none'}
          group={g}
          label={byType ? undefined : (g || t(EMPTY_GROUP_LABEL[groupBy]))}
          logo={groupBy === GROUP_BY_INSTITUTION ? institutionLogo(accountsByGroup[g]) : undefined}
          mixed={!byType}
          accounts={accountsByGroup[g]}
          accountStats={accountStats}
          roiByAccount={roiByAccount}
          currency={currency}
          approx={approx}
          convert={convert}
          multiCurrency={multiCurrency}
          perCurrencyAccountStats={perCurrencyAccountStats}
          selectedAccountId={selectedAccountId}
          onAccountClick={onAccountClick}
          freshness={freshness}
        />
      ))}
    </Box>
  );
}
